export const environment = {
  production: false,
  SUPABASE_URL: "https://bypexxhihjhmlekplrco.supabase.co",
  SUPABASE_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5cGV4eGhpaGpobWxla3BscmNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjkxODMyOTksImV4cCI6MjA0NDc1OTI5OX0.08XG1_JvgejYZYnh7MdUfe6Si4LzL8n5k_EDh5fBTs8",
  IMPORT_TEMPLATE_VERSION: "5.0",
}
